import {
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ViewEncapsulation,
} from '@angular/core';
import { BCRow } from '../../../../../models/bank-records/bank-records-row-search-response';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { Subscription } from 'rxjs';
import { BankRecordsService } from '../../../../../services/bank-records/bank-records.service';
import { MessageService } from 'primeng/api';
import { HttpUtilsBankRecords } from '../../../../../network/http-utilis-bank-records';

@Component({
  selector: 'app-modify-policy-modal',
  standalone: true,
  imports: [
    DialogModule,
    ButtonModule,
    ReactiveFormsModule,
    CommonModule,
    InputTextModule,
    ProgressSpinnerModule,
  ],
  templateUrl: './modify-policy-modal.component.html',
  styleUrl: './modify-policy-modal.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class ModifyPolicyModalComponent
  implements OnInit, OnChanges, OnDestroy
{
  @Input() bankRow: BCRow | undefined;
  form: FormGroup;
  isVisible: boolean = false;
  isLoading: boolean = false;
  subVisibilty$: Subscription | undefined;

  constructor(
    public bankRecordService: BankRecordsService,
    public httpUtilsBankRecords: HttpUtilsBankRecords,
    public messageService: MessageService
  ) {
    this.form = new FormGroup({
      producerCode: new FormControl(null, [Validators.required]),
    });
  }
  ngOnInit(): void {
    this.subVisibilty$ =
      this.bankRecordService.policyModifyModalVisibility.subscribe(
        (isVisible: boolean) => {
          this.isVisible = isVisible;
        }
      );
  }

  ngOnDestroy(): void {
    this.subVisibilty$?.unsubscribe();
  }

  //TODO the BE call need the id of the policy?
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['bankRow'].currentValue !== undefined) {
      this.populateForm();
    }
  }

  populateForm(): void {
    this.form.patchValue({
      producerCode: this.bankRow?.codPdre,
    });
  }

  onDialogHide() {
    this.populateForm();
  }

  onSubmit() {
    let codProducer: string = this.form.get('producerCode')?.value.toString();

    if (codProducer.length >= 4 || codProducer.length === 0) {
      this.messageService.add({
        severity: 'error',
        summary: 'Codice produttore invalido',
        detail: 'Il codice produttore deve essere tra 1 e 3 caratteri.',
        key: 'br',
      });
      return;
    }

    if (codProducer.length < 3) {
      codProducer = codProducer.padStart(3, '0');
    }

    if (!this.bankRow) {
      this.messageService.add({
        severity: 'error',
        summary: 'Errore',
        key: 'br',
        detail: 'Nessuna riga selezionata per la modifica.',
      });
      return;
    }

    this.httpUtilsBankRecords
      .modifyPolicyProducer(this.bankRow.rowId.toString(), codProducer)
      .subscribe({
        next: () => {
          this.bankRecordService.policyProducerReloadRows.next();
          this.bankRecordService.policyModifyModalVisibility.next(false);
          this.messageService.add({
            severity: 'success',
            summary: 'Successo',
            key: 'br',
            detail: `Codice produttore modificato in: ${codProducer}`,
          });
        },
        error: (error) => {
          console.log(error);
          this.messageService.add({
            severity: 'error',
            summary: 'Errore',
            key: 'br',
            detail: `Errore modifica codice produttore: ${error.error.message}`,
          });
        },
      });
  }

  blockInvalidInput(event: KeyboardEvent | ClipboardEvent): void {
    const notAllowedChars = ['e', 'E', '+', '-', '.', ','];

    if (event instanceof KeyboardEvent) {
      if (notAllowedChars.includes(event.key)) {
        event.preventDefault();
      }
    }

    if (event instanceof ClipboardEvent) {
      const pastedText = event.clipboardData?.getData('text') || '';
      if (notAllowedChars.some((char) => pastedText.includes(char))) {
        event.preventDefault();
      }
    }
  }
}
